import { useTranslation } from "react-i18next";
import { SIMPLVmTable } from "../../SimplVmTable";

export const SIMPLVmConfiguration = () => {
  const { t } = useTranslation();

  return (
    <SIMPLVmTable
      type="vm-configuration"
      addButtonLabel={t("AddnewConfig")}
      addModalTitle={t("VmConfigurationManagment")}
      LoadingTitle={t("LoadingVmConfigurations")}
      contentLabel={t("CloudInit")}
      contentMessage={t("Cloud Init is required")}
      placeholder={t("CloudInit")}
      messageRequired={t("MessagesCloudInitRequired")}
    />
  );
};